<div aria-label="document-move-panel">
  <!-- Attachment -->
  <p-panel
    header="Attachments for: {{ activeAuthorization.authorizationNumber }}"
    class="mb-4"
    [toggleable]="true"
    toggler="header"
    [collapsed]="false"
  >
    <ng-template #headericons let-collapsed>
      <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
    </ng-template>
    <mnc-documents-documents-list
      [authorizationByProductId]="activeAuthorization.authorizationId"
      [cancelMove$]="cancelMove"
      [documentFilter]="documentFilter"
      [filterable]="documentsListFilterable"
      [isFaxDisplay]="false"
      [previewColumnFilter]="documentsListPreviewColumnFilter"
      [selectable]="true"
      [showDelete]="true"
      [tenantId]="tenantId"
      [effectiveFromDate]="activeAuthorization.effectiveFromDate"
      [memberDto]="memberDto"
      [parentContext]="'moveDocuments'"
      (deleteCompleted)="onDelete()"
      (selectedDocuments)="selectedFiles = $event"
    ></mnc-documents-documents-list>
  </p-panel>

  <p-panel header="Authorization to move documents" [toggleable]="false">
    <p-input-group class="justify-end">
      <div class="flex py-4 gap-2">
        <input
          aria-label="Authorization Number Input"
          maxlength="17"
          pInputText
          type="text"
          [formControl]="authorizationNumber"
        >
        <button
          icon="pi pi-search"
          iconPos="right"
          pButton
          type="submit"
          [disabled]="!authorizationNumber.valid || isLoading"
          [loading]="isLoading"
          (click)="getAuthorization()"
        ></button>
      </div>
    </p-input-group>
    <div>
      <p-table
        responsiveLayout="scroll"
        [columns]="columns"
        [value]="authReceiverTableData"
      >
        <ng-template pTemplate="colgroup">
          <colgroup>
            @for (col of columns; track col.field) {
              <col [ngStyle]="{ 'width': col.width }">
            }
          </colgroup>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9">No records found.</td>
          </tr>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            @for (col of columns; track col.field) {
              <th>
                @switch (col.field) {
                  @default {
                    <span [innerText]='col.header'></span>
                  }
                }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template let-rowData pTemplate="body">
          <tr>
            @for (col of columns; track $index) {
              <td>
                @switch (col.field) {
                  @case ('memberId') {
                    <span
                      class="truncate"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                      pTooltip="{{ rowData[col.field] }}"
                    >
                    {{ rowData[col.field] }}
                  </span>
                  }
                  @case ('memberName') {
                    <span
                      class="truncate"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                      pTooltip="{{ rowData[col.field] }}"
                    >
                    {{ rowData[col.field] }}
                  </span>
                  }
                  @case ('effectiveFromDate') {
                    {{ rowData[col.field] | date: 'MM/dd/yyyy' : 'UTC' }}
                  }
                  @case ('effectiveToDate') {
                    {{ rowData[col.field] | date: 'MM/dd/yyyy' : 'UTC' }}
                  }
                  @case ('createdOn') {
                    {{ rowData[col.field] | date: 'MM/dd/yyyy hh:mm a' }}
                  }
                  @default {
                    {{ rowData[col.field] }}
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>

      <div class="flex justify-end py-4">
        <div>
          <button
            class="p-button-secondary mr-2 dme-small-action-button"
            label="Cancel"
            pButton
            type="button"
            [disabled]="!authReceiver || !selectedFiles.length"
            (click)="openCancelConfirmationPopup()"
          >
          </button>
          <button
            class="p-button-raised dme-small-action-button"
            label="Move"
            pButton
            type="button"
            [disabled]="!authReceiver || !selectedFiles.length"
            (click)="confirm()"
          >
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</div>
